import Control from 'ol/control/Control'; //import {Control} from 'ol/control';
import ReactDOM from 'react-dom';
import React from 'react';

import Legend from '../../components/legend';

/**
 * @constructor
 * @extends {import('ol/Control').Control}
 * @param {any} geolocation geolocation
 * @param {Object=} options Control options.
 */
class LegendControl extends Control {
	constructor(geolocation, options = {}) {
		super({
			element: document.createElement('button'),
			...options,
		});

		this.isLegendOpen = false;

		this.element.setAttribute('class', 'bssp-legend-control');
		this.element.setAttribute('type', 'button');
		this.element.setAttribute('aria-controls', 'bssp-legend-modal');
		this.element.addEventListener('click', (e) => {
			e.stopPropagation();
			this.setIsLegendOpen(!this.isLegendOpen);
		});

		this.renderLegend();
	}

	setIsLegendOpen(value) {
		this.isLegendOpen = value;
		this.renderLegend();
	}

	renderLegend() {
		ReactDOM.render(
			<Legend
				isOpen={this.isLegendOpen}
				setIsOpen={(value) => {
					this.setIsLegendOpen(!!value);
				}}
			/>,
			this.element
		);
	}
}

export default function () {
	const legendControl = new LegendControl();

	return {
		legendControl: legendControl,
	};
}
